import { useEffect } from "react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SponsorShowcase = ({ sponsors = [] }) => {
  useEffect(() => {
    sponsors.slice(0, 3).forEach((sponsor) => {
      axios.post(`${API_BASE}/sponsors/${sponsor.id}/impression`).catch(() => {});
    });
  }, [sponsors]);

  return (
    <section className="border border-[#D9DCE1] bg-white p-6 shadow-[0_20px_60px_rgba(15,23,42,0.04)] sm:p-8" data-testid="sponsor-showcase-section">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#3BB143]" data-testid="sponsor-showcase-overline">Sponsor showcase</p>
          <h2 className="mt-3 font-[Bebas_Neue] text-4xl uppercase tracking-[0.04em] text-[#0A0A0A]" data-testid="sponsor-showcase-title">Local partners supporting independent reporting</h2>
        </div>
        <p className="max-w-xl text-sm leading-7 text-slate-700" data-testid="sponsor-showcase-copy">Gold, silver, and bronze sponsors can appear on the homepage, livestream coverage, and newsroom category pages.</p>
      </div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3" data-testid="sponsor-showcase-grid">
        {sponsors.map((sponsor, index) => (
          <article key={sponsor.id} className="border border-[#D9DCE1] bg-[#F8F9FA] p-5 sm:p-6" data-testid={`sponsor-card-${index}`}>
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#1338BE]" data-testid={`sponsor-tier-${index}`}>{sponsor.tier} sponsor</p>
            <div className="mt-4 flex h-20 items-center justify-center overflow-hidden border border-[#D9DCE1] bg-white p-3" data-testid={`sponsor-logo-slot-${index}`}>
              {sponsor.logo_url ? <img alt={`${sponsor.name} logo`} className="h-full w-full object-contain" src={sponsor.logo_url} /> : <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-400">Logo space</span>}
            </div>
            <h3 className="mt-4 font-[Montserrat] text-xl font-bold uppercase tracking-[0.08em] text-[#0A0A0A]" data-testid={`sponsor-name-${index}`}>{sponsor.name}</h3>
            <p className="mt-3 text-sm leading-7 text-slate-700" data-testid={`sponsor-description-${index}`}>{sponsor.description}</p>
            <div className="mt-5 space-y-1.5 text-sm text-slate-700">
              {sponsor.phone ? <p data-testid={`sponsor-phone-${index}`}>{sponsor.phone}</p> : null}
              {sponsor.promotional_offer ? <p data-testid={`sponsor-offer-${index}`}>{sponsor.promotional_offer}</p> : null}
            </div>
            {sponsor.website_url ? (
              <a
                className="mt-6 inline-flex border border-[#0A0A0A] px-4 py-3 text-xs font-bold uppercase tracking-[0.18em] text-[#0A0A0A] transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#0A0A0A] hover:text-white"
                data-testid={`sponsor-visit-link-${index}`}
                href={sponsor.website_url}
                onClick={() => axios.post(`${API_BASE}/sponsors/${sponsor.id}/click`).catch(() => {})}
                rel="noreferrer"
                target="_blank"
              >
                Visit website
              </a>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
};